"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    props: {
        size: Array,
        path: String,
        id: String,
        map: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            wasDeactivated: false,
            slot: null
        };
    },
    beforeCreate: function beforeCreate() {},
    mounted: function mounted() {
        var path = this.path,
            size = this.size,
            id = this.id;

        this.$state.adsSlots.push({
            path: path,
            size: size,
            id: id,
            map: this.map
        });
    },
    deactivated: function deactivated() {
        this.wasDeactivated = true;
    },
    activated: function activated() {}
};


//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/customized-core/Ad.vue
// module id = fcd8
// module chunks = 1